import React,{useMemo,useState} from 'react';
import {FiArrowRight,FiBell,FiCheck,FiGitBranch,FiRefreshCw} from 'react-icons/fi';
import {draftAvailable,previewDraftBlocks,draftProposedOrder} from '../lib/clientStoryDraft';
import {compareStoryVersions} from '../lib/storyVersions';
import {feedbackStatusLabel} from '../lib/feedbackInbox';

const kindLabels={
 review_submitted:'Review submitted',review_changes_requested:'Changes requested',
 review_approved:'Story approved',draft_submitted:'Client Story Draft submitted',
 passage_feedback:'Interview feedback',story_comment:'Story passage comment'
};
const clipText=(text,n=130)=>text?.length>n?text.slice(0,n)+'…':text||'';
export default function ReviewActivityAndDrafts({items=[],drafts=[],snapshot,paper,feedback=[],unread=0,
 onApply,onAccept,onMarkRead,busy=false}){
 const [showActivity,setShowActivity]=useState(false);
 const [active,setActive]=useState(null);
 const [showCompare,setShowCompare]=useState('published');
 const draft=drafts.find(d=>d.review_version+':'+d.guest_email+':'+d.updated_at===active)||drafts[0];
 const options=useMemo(()=>draftAvailable(snapshot||{blocks:[],sources:[]},feedback.filter(n=>n.kind==='select'&&n.review_version===draft?.review_version &&
    draft?.sequence?.some(item=>item.type==='select'&&item.id===n.id))),[snapshot,feedback,draft]);
 const preview=useMemo(()=>{
   if(!draft||!snapshot)return null;
   try{const blocks=previewDraftBlocks(draft.sequence,options);
    const base={blocks:showCompare==='published'?snapshot.blocks||[]:paper?.blocks||[],sectionHeadings:[]};
    return {diff:compareStoryVersions(base,{blocks,sectionHeadings:[]}),blocks,needsSelection:draft.sequence.filter(i=>
      i.type==='select'&&!paper?.blocks?.some(b=>b.reviewFeedbackId===i.id)),
      order:draftProposedOrder(paper||{blocks:[]},draft.sequence,options)};
   }catch{return null;}
 },[draft,options,paper,snapshot,showCompare]);
 const sorted=[...drafts].sort((a,b)=>String(b.updated_at).localeCompare(String(a.updated_at)));
 return <div className="takefold-draft-activity">
   <div className="takefold-activity-head">
    <button type="button" onClick={()=>setShowActivity(v=>!v)} aria-expanded={showActivity}>
      <FiBell/> Review activity {unread>0&&<span>{unread} new</span>}
    </button>
    {showActivity&&unread>0&&<button type="button" onClick={onMarkRead} disabled={busy}>Mark all read</button>}
   </div>
   {showActivity&&<div className="takefold-activity-list">
    {items.length===0&&<p>No recent review activity yet.</p>}
    {items.slice(0,30).map(item=><div key={item.id} className={'takefold-activity-line'+(!item.read_at?' is-unread':'')}>
      <strong>{kindLabels[item.kind]||'Review update'}</strong>
      <span>{item.guest_name||'Reviewer'} · Review v{item.review_version}</span>
      <small>{new Date(item.created_at).toLocaleString()}</small>
    </div>)}
    <small>Notifications appear here as reviewers submit feedback, drafts and decisions. Email delivery depends on a configured sender.</small>
   </div>}
   <div className="takefold-draft-heading"><FiGitBranch/> <strong>Client Story Drafts</strong><span>{drafts.length}</span></div>
   {drafts.length===0?<p className="takefold-draft-empty">When a Contributor or Approver submits a proposed Story order, you can compare it here. Your working edit stays unchanged.</p>:
   <div className="takefold-draft-list">
     {sorted.map(d=><button type="button" key={d.review_version+':'+d.guest_email} className={draft===d?'is-selected':''}
       onClick={()=>setActive(d.review_version+':'+d.guest_email+':'+d.updated_at)}><strong>{d.guest_name}</strong><span>Review v{d.review_version} · {d.sequence?.length||0} passages</span>
       <small>{new Date(d.updated_at).toLocaleString()}</small></button>)}
   </div>}
   {draft&&preview&&<section className="takefold-draft-compare">
     <div className="takefold-draft-compare-head"><strong>{draft.guest_name}'s suggested Story</strong>
       <label>Compare with
        <select value={showCompare} onChange={e=>setShowCompare(e.target.value)}>
         <option value="published">Published review</option><option value="working">Current Story</option>
        </select></label>
     </div>
     {draft.note&&<blockquote>{draft.note}</blockquote>}
     <div className="takefold-draft-diff">
      <span>+{preview.diff.added.length} added</span><span>−{preview.diff.removed.length} omitted</span>
      <span>{preview.diff.moved.length} reordered</span><span>{preview.diff.changed.length} changed</span>
     </div>
     <div className="takefold-draft-passages">
      {preview.blocks.map((b,i)=><article key={b.id}><strong>{i+1}. {clipText(b.text,105)}</strong>
       <small>{b.reviewFeedbackId?'Suggested select':'Published passage'}{preview.diff.timeline[i]?.moved?' · Reordered':''}</small>
       {b.reviewFeedbackId&&!paper?.blocks?.some(x=>x.reviewFeedbackId===b.reviewFeedbackId)&&
         <button type="button" disabled={busy} onClick={()=>onAccept?.(b.reviewFeedbackId)}>Add this select to Story</button>}
      </article>)}
     </div>
     <p>Importing order rearranges existing Story passages only. It does not remove clips. Add missing selects individually first; the current edit is saved as a version before any reorder.</p>
     <button type="button" className="review-primary" disabled={busy||!paper?.blocks?.length||
        preview.order.every((b,i)=>b.id===paper.blocks[i]?.id)}
       onClick={()=>onApply?.(draft,options)}><FiArrowRight/> Apply proposed order</button>
   </section>}
  </div>;
}
